export enum ErrorCode {
  SUCCESS = 0,
  VerifySuccess = 1, // temporary, should be changed
  DATABASE_ERROR = 100,
  SESSION_EXPIRED = 101,
  UNATHORIZED_FOR_OPERATION = 102,
  TRANSACTION_FAILED = 103,
  SERVER_ERROR = 500,
  FINISHED_WITH_MINOR_ERRORS = 510,
  NO_ACCESS_TO_TOPIC = 2001,
  TOPIC_DOES_NOT_EXIST_IN_ROOM = 2002,
  TOPIC_LOCKED_BY_CURRENT_USER = 2005,
  TOPIC_LOCKED_BY_ANOTHER_USER = 2006,
  TOPIC_IS_NOT_LOCKED = 2008,
  TOPIC_DOES_NOT_EXIST = 2009,
  PARENT_TOPIC_DOESNT_EXIST_FOR_SITE = 2012,
  NO_ACCESS_TO_PARENT_TOPIC = 2013,
  TOPIC_NAME_BLANK = 2024,
  NO_RESULTS_FOUND = 2051,
  FIELD_MAP_DOES_NOT_EXIST = 2053,
  CREATE_TOPIC_EXCEPTION = 2055,
  TOPIC_ALREADY_EXISTS = 2044,
  TOPIC_IS_REFERENCED = 2063,
  FIELD_USED_WF_INIT_STAGE = 3073,
  FIELD_USED_WF_STAGE_ACTION = 3074,
  FIELD_USED_WF_CUSTOM_FIELDS = 3076,
  FIELD_USED_WF_SET_FIELDS_ACTION = 3077,
  CUSTOM_FORM_UPDATE_FAILED = 3200,
  REQUIRED_FIELD_MUST_BE_IN_CODING = 3079,
  NON_CHANGEABLE_FLAG_WAS_NOT_CHANGED = 3081,
  FORM_USED_IN_WORKFLOW = 3091,
  FILE_WAS_NOT_UPLOADED = 4003,
  BAD_FILE_NAME_OR_CONTENT = 4011,
  ATTACHMENT_HAS_RESTRICTED_CONTENT = 4048,
  DOCUMENT_IS_INFECTED_WITH_VIRUS = 4049,
  NO_FILE_FOUND = 4051,
  DOCUMENT_NOT_YET_REDACTED = 4052,
  USER_NOT_AUTHORIZED_TO_DOWNLOAD_FILE = 4055,
  CANNOT_DELETE_DOC_FROM_LINKED_ROOM = 4085,
  TOPIC_DOESNT_CONTAIN_FILES = 4101,
  INCORRECT_INPUT_PARAMETERS = 4100,
  LOGGER_OBJECT_IS_NULL = 4105,
  INCORRECT_FILE_TYPE = 4110,
  INPUT_DOCLIST_EMPTY = 4115,
  SIGN_ACCESS_RECTRICTED = 4120,
  ESIGN_ACCDATA_NOT_FOUND = 4125,
  ESIGN_SERVICE_UNAVAIL = 4130,
  USER_DONT_HAVE_ESIGN = 4135,
  DOC_ALREADY_SIGNED = 4140,
  DOC_FILE_NOT_FOUND = 4145,
  CANT_READ_SOURCE_FILE = 4150,
  ADD_TOPIC_FILE_FAILED = 4155,
  ADD_DOCS_SIGN_FAILED = 4160,
  UNKNOWN_EXC_IN_COSING_MOD = 4165,
  UNKNOWN_ERR_FROM_COSING_MOD = 4170,
  COMM_ERROR_WITH_COSIGN = 4175,
  ESIGN_MOD_RET_EMPTY_DOC = 4180,
  INPUT_CONTENT_IS_EMPTY = 4185,
  DUPLICATE_DOCUMENT_NAME = 4186,
  EXCLUDING_FROM_WF_DUPLICATE_DOCUMENT_NAME = 4187,
  MANUAL_DOC_NAME_UPDATE_IS_NOT_ALLOWED = 4188,
  VALUE_FOR_THE_REQUIRED_FIELD_IS_NOT_PROVIDED = 4203,
  DOCUMENT_VERSIONING_NOT_SUPPORTED = 4207,
  DOCUMENT_FILE_PREVIEW_IS_NOT_AVAILABLE = 4209,
  DOCUMENT_LOCKED_PUBLISHED_TO_ETMF = 4210,
  DOCUMENT_IS_EDITED_BY_USER = 4220,
  ETMF_DOESNT_HAVE_MATCHING_DOCUMENT_TYPE = 4222,
  ETMF_DOESNT_HAVE_MATCHING_INVESTIGATIVE_SITE = 4223,
  CONTACT_DOESNT_MATCH_IN_ETMF = 4224,
  DOCUMENT_ALREADY_EXIST_IN_ETMF_BY_TITLE = 4225,
  UNABLE_TO_DISABLE_SHARED_WORKSPACE_FUNCTIONALITY = 4226,
  DOCUMENT_ALREADY_EXIST_IN_ETMF_BY_NAME = 4227,
  FILE_IS_TOO_BIG_TO_OPEN = 4253,
  KEYWORDSET_DOES_NOT_EXIST = 4509,
  FIELD_TYPE_MISMATCH = 4600,
  FIELDS_DETAILS_CANNOT_BE_NULL = 5513,
  EXPORT_WAS_REDIRECTED_TO_FTP = 5672,
  ANOTHER_EXPORT_TASK_PENDING = 5675,
  MULTIPLE_TOPIC_TYPES_NOT_SUPPORTED_MASS_CODING = 5680,
  ONLY_FIELDS_INCLUDE_IN_MASS_CODING_ALLOWED = 5681,
  READ_ONLY_FIELDS_NOT_ALLOWED_MASS_CODING = 5682,
  FIELDS_NOT_SUPPORTED_MASS_CODING = 5683,
  NON_EXISTING_METADATA_FIELDS_NOT_SUPPORTED_MASS_CODING = 5684,
  USER_DOES_NOT_EXIST = 6001,
  WRONG_OLD_PASSWORD = 6003,
  IMPOSSIBLE_TO_EDIT_DEACTIVATED_USER = 6004,
  CREATE_USER_ERROR = 6017,
  USER_GROUP_DOES_NOT_BELONG_TO_THE_SITE = 6022,
  NO_ACCESS_TO_PERFORM_OPERATION = 6031,
  PASS_CANT_BE_EMPTY = 6230,
  USER_NOT_LOGGED_IN = 6051,
  USER_DOES_NOT_EXIST_FOR_THE_SITE = 6057,
  CANNOT_GET_USER_DETAILS = 6062,
  UNABLE_TO_SEND_MAIL = 6068,
  USER_GROUP_WITH_THIS_NAME_EXISTS = 6085,
  PIN_IS_NOT_VALID = 6090,
  TO_MANY_LOGIN_ATTEMPTS_FAILED = 6091,
  USER_TEMPORARY_PASSWORD_IS_EXPIRED = 6094,
  USER_PASSWORD_IS_EXPIRED = 6072,
  SET_PASSWORD_ON_SILENT_INVITE_FAILED = 6096,
  CANNOT_MODIFY_SYSTEM_USER = 6101,
  IP_NOT_ALLOWED = 6150,
  INVALID_CREDENTIALS = 6151,
  DEACTIVATED_USER_CANNOT_LOGIN = 6153,
  RESET_PASSWORD_IS_OFF_FOR_DOMAIN = 6208,
  LINK_HAS_EXPIRED = 6211,
  PASSWORD_ALREADY_RESET = 6213,
  ANSWERS_NOT_CORRECT = 6214,
  ANSWERS_NOT_SET = 6216,
  LINK_IS_INVALID = 6217,
  FIELD_TOO_LONG = 6226,
  ANSWERS_REQUIRED = 6229,
  UNABLE_DELETE_USER_CRA_OR_SAS_IN_INVESTIGATIVE_SITE = 6232,
  USER_IS_PRINCIPAL_INVESTIGATOR = 6233,
  RESTRICTED_USER = 6237,
  CA_TOPIC_NOT_FOUND = 6323,
  CA_ACCEPT_REQUIRED = 6324,
  CA_DISMISSED = 6325,
  CA_NOT_ACCEPTED = 6326,
  PROJECT_CODE_ALREADY_USED = 6337,
  CREATE_DEACTIVATED_USER_ERROR = 6152,
  INCORRECT_AUTH_TYPE = 6203,
  SECURITY_PROVIDER_NOT_AVAILABLE = 6205,
  USER_DOES_NOT_HAVE_ACCESS_TO_ROOM = 6301,
  ROOM_NAME_ALREADY_EXISTS = 6302,
  ROOM_CREATED_WITH_ISSUES = 6342,
  UNABLE_TO_DELETE_DOCUMENT_IN_WORKFLOW = 9106,
  UNABLE_TO_CHANGE_FINAL_STATUS = 9112,
  UNABLE_TO_EXCLUDE_TOPICS_FROM_WORKFLOW = 9113,
  DELETE_WORKFLOWS_FAILED = 9114,
  MASS_TOPIC_CLAIM_FAILED = 9115,
  MASS_TOPIC_UNCLAIM_FAILED = 9116,
  UPDATE_WORKFLOW_FAILED = 9120,
  SELECT_WORKFLOW = 9140,
  WORKFLOW_CREATION_ERROR = 9999,
  TOPIC_NAMES_COLLISION = 10008,
  DOCUMENT_RESTORE_ERROR = 10011,
  ARCHIVE_UPLOAD_PARTIAL_SUCCESS = 10120,
  AUTO_INDEXING_ERROR = 10042,
  NO_PARENT_TOPIC_FOR_RESTORE = 10060,
  FILE_TYPE_RESTRICTION = 10180,
  FILE_PARSING_FAILED = 10181,
  WRONG_FINAL_STATUS_INDEX = 10197,
  UNABLE_DELETE_DOCTYPE_RELATED_FOLDERS = 10198,
  MOVE_DOCUMENTS_FINISHED_WITH_ERRORS = 10201,
  DOCUMENT_WAS_NOT_SUBMITTED_FOR_SIGNING = 10204,
  DUPLICATE_SIGNER_WITHIN_REQUEST = 10205,
  SIGNER_DOESNT_EXIST_WITHIN_REQUEST = 10206,
  SIGN_FILE_TOO_LARGE = 10207,
  UNSUPPORTED_ESIGNATURE_FILE_TYPE = 10208,
  FILE_VALIDATION_IS_FAILED = 10209,
  DOCUMENT_TRANSIENT_UPLOAD_FAILED = 10220,
  EMPTY_DOCUMENT_CONTENT = 10232,
  INBOX_DOMAIN_ADDRESS_IS_NOT_UNIQUE = 12000,
  INBOX_EMAIL_ADDRESS_ALREADY_REGISTERED = 12001,
  REQUEST_TO_INBOX_SERVER_HAS_FAILED = 12002,
  INBOX_EMAIL_VALIDATION_HAS_FAILED = 12003,
  THE_SITE_START_UP_INBOX_EMAIL_ADDRESS_IS_NOT_UNIQUE = 12004,
  THE_COMMUNICATION_INBOX_EMAIL_ADDRESS_IS_NOT_UNIQUE = 12005,
  UNABLE_ATTACH_FILE_TO_EMAIL = 11023,
  WAITING_FOR_SIGNATURE = 10216,
  ESIGN_SIGNERS_MISMATCH = 10240,
  NOT_SUITABLE_QUESTION = 13005,
  NOT_SUITABLE_ANSWER = 13006,
  AT_LEAST_ANSWER_PARENT_EXPECTED = 13007,
  SUBJECT_MATTER_NOT_AVAILABLE_TO_REMOVAL = 13008,
  EXPORT_QA_NO_FIELDS_SELECTED = 13013,
  EMPTY_NAMES_ARE_NOT_ALLOWED_FOR_INVESTIGATIVE_SITES = 13031,
  SITE_WITH_SUCH_NAME_AND_PI_ALREADY_EXISTS = 13033,
  CANT_DETERMINE_INDEX_FOR_IS_DOCUMENT = 13043,
  SITE_WITH_SPECIFIED_NUMBER_EXISTS = 13045,
  CONTACTS_CONFLICT_DURING_MASS_CODING = 13047,
  CANT_CHANGE_INVESTIGATIVE_SITE_STATUS = 13050,
  CRA_DOES_NOT_EXIST = 13053,
  SAS_SHOULD_BE_EDITOR_OR_HIGHER = 13055,
  CRA_SHOULD_BE_EDITOR_OR_READER = 13058,
  CANT_ADD_CONTACT_TWICE = 13059,
  CONTACT_TYPE_CATEGORY_ALREADY_EXISTS = 13060,
  CANNOT_CREATE_INVESTIGATIVE_SITE_WITHOUT_PI = 13063,
  IMPORT_INVESTIGATIVE_SITE_DATA_ERROR = 13065,
  SET_STARTUP_SPECIALIST_IN_MASS_CODING_ERROR = 13066,
  NO_DOCS_TO_SEND_IN_REG_PACKET = 13067,
  REG_PACKET_SENDING_ERROR = 13068,
  CANT_SEND_REG_PACKET_TO_ACTIVATED_SITE_ERROR = 13091,
  INV_SITE_STATUS_CHANGED_WITH_ISSUES = 13096,
  NO_SITES_FOR_SELECTED_COUNTRY = 13097,
  JOB_DOES_NOT_EXIST = 14101,
  CONTACT_ALREADY_EXIST_WITH_DIFF_SPONSOR = 14115,
  CONTACT_ALREADY_EXIST_WITH_DIFF_NAME = 14116,
  SPONSOR_CONTACT_ID_FIELD_SHOULD_BE_UNIQUE = 14118,
  CONTACT_CANNOT_BE_REMOVED = 14119,
  ONLY_MANAGER_OR_HIGHER_ALLOWED_CHANGE_CONTACTS_NAMES_IN_MULTIPLE_DATA_ROOMS = 14124,
  PATTERN_PARSING_ERROR = 14249,
  IRB_CREATE_NOT_ALL_DATA_PROVIDED = 15000,
  IRB_CREATE_FAILED = 15001,
  IRB_MODIFY_FAILED = 15002,
  IRB_DELETE_FAILED = 15003,
  COMMITTEE_CREATE_NOT_ALL_DATA_PROVIDED = 15100,
  COMMITTEE_CREATE_FAILED = 15101,
  COMMITTEE_MODIFY = 15102,
  COMMITTEE_DELETE_FAILED = 15103,
  IRB_CREATE_IN_DATA_ROOM_FAILED = 15004,
  IRB_DELETE_IN_DATA_ROOM_FAILED = 15005,
  IRB_ALREADY_EXISTS_IN_DATA_ROOM = 15006,
  IRB_USED_BY_INV_SITE = 15011,
  IRB_IS_USED_IN_DOCUMENT_PROFILE = 15013,
  CENTRAL_IRB_IS_REQUIRED = 15019,
  SSU_SAVE_ESSENTIAL_DOCS_ERROR = 15300,
  ESSENTIAL_DOCS_ALREADY_HAS_PROFILE = 15310,
  SSU_NOTIFICATION_FAILED = 15380,
  ERROR_OCCURRED_WHILE_CHANGING_ESSENTIAL_DOCUMENT_STATUS = 15390,
  DOCUMENT_HAS_OPEN_QUERIES_PLEASE_RESOLVE_THEM_BEFORE_FURTHER_PROCESSING = 15400,
  CREATE_COMMUNCATION_LOG_FAILED = 16101,
  SAVE_COMMUNCATION_LOG_FAILED = 16106,
  DELETE_DOCUMENT_TYPE_FAILED = 16200,
  DOCUMENT_TYPE_HAS_CHILD_DOCUMENT_TYPES = 16201,
  DOCUMENT_TYPE_IMPORT_IN_COUNTRY_OR_IRB_FAILED = 16202,
  DOCUMENT_TYPE_IMPORT_FAILED = 16205,
  DOCUMENT_TYPE_PARENT_NOT_ALLOWED_TO_HAVE_KEYWORDS = 16208,
  DOCTYPE_CUSTOM_FORM_EXISTS = 16214,
  IRB_DOCUMENT_TYPE_ID_SHOULD_BE_UNIQUE = 16216,
  CTMS_DOCUMENT_TYPE_ID_SHOULD_BE_UNIQUE = 16218,
  DOCUMENT_TYPE_ID_SHOULD_BE_UNIQUE = 16219,
  CREATE_REQUIRED_DOCUMENT_FAILED = 16301,
  DELETE_REQUIRED_DOCUMENT_FAILED = 16303,
  CREATE_COUNTRY_FAILED = 16401,
  MODIFY_COUNTRY_FAILED = 16402,
  DELETE_COUNTRY_FAILED = 16403,
  UNABLE_TO_DELETE_TASK_STATUS = 16504,
  TASK_STATUS_ALREADY_IN_USE = 16505,
  UNABLE_TO_DELETE_TASK_CATEGORY = 16506,
  ESIGN_AUTHORIZATION_REQUIRED = 16601,
  ESIGN_REASON_NOT_PROVIDED = 16602,
  USER_IS_NOT_ELIGIBLE_TO_SIGN = 16610,
  ROOM_TYPE_IN_SOURCE_FILE_DOES_NOT_MATCH_SELECTED_ROOM_TYPE = 16703,
  ERRORS_WHILE_DOCUMENT_IMPORT = 16800,
  DOCUMENT_CATEGORY_DOES_NOT_EXIST = 16801,
  DOCUMENT_INVESTIGATIVE_SITE_DOES_NOT_EXIST = 16802,
  DOCUMENT_CONTACT_REVIEW_DOES_NOT_EXIST = 16803,
  DOCUMENT_TYPE_DOES_NOT_EXIST = 16804,
  DOCUMENT_STATUS_DOES_NOT_EXIST = 16805,
  DOCUMENT_PUBLISHED_BY_USER_DOES_NOT_EXIST = 16806,
  DOCUMENT_IRB_EC_DOES_NOT_EXIST = 16807,
  DOCUMENT_COUNTRY_DOES_NOT_EXIST = 16808,
  ERRORS_WHILE_INV_SITE_IMPORT = 16820,
  INV_SITE_COUNTRY_DOES_NOT_EXIST = 16821,
  INV_SITE_CONTACT_TYPE_DOES_NOT_EXIST = 16822,
  INV_SITE_IRB_EC_DOES_NOT_EXIST = 16826,
  INV_SITE_PREFERRED_COMMUNICATION_MODE_DOES_NOT_EXIST = 16827,
  DUPLICATE_AUDIT_PROFILE_NAME = 17013,
  UNABLE_TO_DELETE_AUDIT_STATUS = 17000,
  AUDIT_PROFILE_DOES_NOT_HAVE_ANY_ACTIVE_AUDITORS = 17039,
  OO_SERVER_IS_DOWN = 18053,
  DOCUMENT_IS_EDITED_ONLINE_BY_ANOTHER_USER = 18056,
  DOCUMENT_ALREADY_CHECKED_OUT = 18059,
  REVIEW_DOCUMENT_DOES_NOT_EXIST = 18060,
  REPLACE_DOCUMENT_CONTENT_FAILED = 18061,
  CANT_COMPLETE_AMENDMENT = 20404,
  AMENDMENT_COMPLETED_WITH_ISSUES = 20405,
  FIELD_FORM_LOCKED = 18000,
  MILESTONE_OPERATION_FAILED = 20300,
  EVENT_CANNOT_BE_ASSIGNED = 20307,
  PLEASE_REVIEW_NOT_AVAILABLE = 21050,
  PLEASE_REVIEW_STATUS_WAS_CHANGED = 21070,
  AUTHORING_REVIEW_DOES_NOT_EXIST = 21011,
  DOCUMENT_LOCKED_FOR_EDIT_ONLINE_OPERATION = 22001,
  MINOR_ERRROR_WHILE_SEARCH = 23101,
  CRITICAL_ERRROR_WHILE_SEARCH = 23102,
  UPLOAD_NOT_FOUND = 27000,
  ARGUMENT_IS_OUT_OF_RANGE = 27001,
  INVALID_ARGUMENT = 27003,
  UPLOAD_SESSION_EXPIRED = 27004,
  SESSION_EXPIRED2 = 100000,
  PARALLEL_LOGIN = 100001,
  TEMPORARY_LOGIN = 100002,
  TASK_COMPLETED_WITH_ERRORS = 100003,
  MAINTENANCE_IN_PROGRESS = 100004,
  CAS_TICKET_VALIDATION_ERROR = 100005,
  ACCOUNT_NOT_EXISTS = 100006,
  CAS_SIGNOUT = 100007,
  TIMEOUT_SIGNOUT = 100008,
  SUPERADMIN_SIGNOUT = 100009,
  MILESTONE_HAS_RELATED_DATAROOM = 20301,
  CHILD_MILESTONE_IS_ENABLED = 20302,
  USER_SESSION_DOES_NOT_EXIST = 100010,
  USER_VALIDATION_REQUIRED = 100011,
  VALIDATED_USER_DIFFERS_FROM_CURRENT = 100012,
  USER_IDENTITY_VALIDATION_ERROR = 100013,
  INVALID_SSO_USER = 100015,
  AUTHORING_REVIEW_NAME_IS_DUPLICATED = 21002,
  RESPONSIBLE_DEPARTMENT_CANNOT_BE_DELETED_DUE_TO_ASSOCIATED_DOCUMENT_TYPES = 222011,
  ENTITY_IS_NOT_APPLICABLE_FOR_THE_PROVIDED_AMENDMENT = 20415,
  UNABLE_TO_DELETE_GROUP_REFERENCED_IN_THE_AUDIT_PROFILE = 6228,
  FIELD_FLAG_CONFLICT = 3080,
  EFFECTIVENESS_CHECK_IS_MISSING = 25320,
  RELATED_RECORDS_CAN_BE_CLOSED = 25321,
  NO_MATCHING_WF = 9141,
  CREATE_DOCUMENT_DOC_TYPE_DOES_NOT_EXIST = 10004,
  FAILED_TO_POPULATE_FILE_PROCESSING_QUEUE = 18102,
  FAILED_TO_POPULATE_INDEXING_QUEUE_AFTER_ADDING_TOPIC_FILE = 23201,
}
